const toggleFreeformTable = () => {

  jQuery( '.module--freeform-table .freeform-table-open-btn' ).each( ( index, el ) => {
    if ( jQuery( el ).hasClass( 'show-by-default' ) ) {
      jQuery( el ).next( '.freeform-table-wrapper' ).slideDown();
    }

    jQuery( el ).click( ( event ) => {
      jQuery( event.currentTarget ).toggleClass( 'show' );
      jQuery( event.currentTarget ).next( '.freeform-table-wrapper' ).slideToggle();
    });
  });

};

jQuery( () => {
  toggleFreeformTable();
});
